<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Site Sessions"
              icon="fas fa-list">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <div class="d-flex justify-content-end">
                <table-action-bar (toggleColumns)="columnOptionsSidebarVisible = true"></table-action-bar>
              </div>
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table
                      [resizableColumns]="true"
                      [autoLayout]="true"
                      [value]="siteSessions"
                      (onSort)="customSort($event)"
                      [sortField]="defaultSortField"
                      [sortOrder]="defaultSortOrder"
                      [lazy]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Site Session Id</th>
                        <th>Worker</th>
                        <th>Company</th>
                        <th>Reason</th>
                        <th [pSortableColumn]="'startTime'">Start Time
                          <p-sortIcon [field]="'startTime'"></p-sortIcon>
                        </th>
                        <th>End Time</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Guests')">Guests</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Notes')">Notes</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Photos')">Photos</th>
                        <th *ngIf="tableOptions.visibleColumns.includes('Site Forms')">Site Forms</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-workerSession>
                      <tr [pSelectableRow]="workerSession">
                        <td>{{workerSession.siteSession.id}}</td>
                        <td>{{workerSession.user.firstName}} {{workerSession.user.lastName}}</td>
                        <td>{{workerSession.user.workerUser.maintenance.name}}</td>
                        <td>{{workerSession.reason}}</td>
                        <td>{{workerSession.startTime | date : 'yyyy-MM-dd HH:mm'}}</td>
                        <!-- First End Time handles site session that has ended and has an end time
                            Second End Time handles a site session that is still open -->
                        <td *ngIf="workerSession.endTime !== null">{{workerSession.endTime | date : 'yyyy-MM-dd HH:mm'}}</td>
                        <td *ngIf="workerSession.endTime === null">
                          <span class="badge badge-pill badge-success">Session open</span>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Guests')">{{workerSession.guestCount}}</td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Notes')">
                          <a *ngIf="workerSession.notes !== null" href="javascript:void(0)" (click)="viewNotes(workerSession.notes)"><i class="fa fa-file" aria-hidden="true"></i></a>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Photos')">
                          <a *ngIf="workerSession.siteSession.uploadCount > 0" href="javascript:void(0)" (click)="viewPhotos(workerSession.id)"><i class="fa fa-images" aria-hidden="true"></i></a>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Site Forms') && workerSession.siteFormResponseCount > 0">
                          <a href="javascript:void(0)" (click)="viewSiteForms(workerSession)">{{ workerSession.siteFormResponseCount }}</a>
                        </td>
                        <td *ngIf="tableOptions.visibleColumns.includes('Site Forms') && workerSession.siteFormResponseCount === 0">0</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="20">No work orders found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator
                #paginator
                [rows]="pagination.size"
                [totalRecords]="pagination.totalRecords"
                [rowsPerPageOptions]="pageSizes"
                (onPageChange)="paginate($event)">
              </p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
